import { render, staticRenderFns } from "./ProyectoForm.vue?vue&type=template&id=2a2dd218&"
import script from "./ProyectoForm.vue?vue&type=script&lang=js&"
export * from "./ProyectoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports